exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2tk3AvsN5PNZOlngoPjdJG {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  margin-left: auto;\n  padding: 0;\n  border: 1px solid var(--heavy-line-outline-color);\n  border-radius: 5px;\n  background: none;\n  cursor: pointer;\n  color: var(--secondary-text-color);\n}\n\n._2tk3AvsN5PNZOlngoPjdJG:hover {\n  background-color: var(--light-line-divider-color);\n}\n", ""]);

// Exports
exports.locals = {
	"toggleButton": "_2tk3AvsN5PNZOlngoPjdJG"
};